import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { push } from 'react-router-redux';
import { blue700 } from 'material-ui/styles/colors';
import EventIcon from 'material-ui/svg-icons/action/date-range';
import { withTranslation } from 'react-i18next';

let SelectableList = makeSelectable(List);

const items = ['/event-tickets/events'];

class EventTicketNavigation extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            selectedIndex: Math.max(items.indexOf(window.location.pathname + window.location.search), 0),
        };
    }

    render() {
        const { push, t } = this.props;

        return (
            <div>
                <div id="administration" className="col-md-2 sidebar-listview">
                    <SelectableList
                        selectedItemStyle={{
                            backgroundColor: '#0a71ba1a',
                        }}
                        value={this.state.selectedIndex}
                        onChange={(event, index) => this.setState({ selectedIndex: index })}>
                        <ListItem
                            className="styled-list-item"
                            key={0}
                            value={0}
                            primaryText={t('common_phrases.events')}
                            leftIcon={<EventIcon color={blue700} />}
                            onClick={() => push('/event-tickets/events')}
                        />
                    </SelectableList>
                </div>
                <div className="col-md-10">{this.props.children}</div>
            </div>
        );
    }
}

export default withTranslation()(connect(null, { push })(EventTicketNavigation));
